import { observer } from 'mobx-react';
import { useFormContext } from 'react-hook-form';
import { forwardRef } from 'react';
import AutoComplete from './AutoComplete';

const ServiceProviderLocation = forwardRef(({ field, ...props }, ref) => {
  const nameKey = 'locationName';
  const valueKey = 'id';

  const searchKey = 'locationName';

  const { getValues } = useFormContext();
  const serviceProviderId = getValues('serviceProviderId');
  const apiPath = `service-providers/${serviceProviderId}/locations`;

  return (
    <AutoComplete
      ref={ref}
      nameKey={nameKey}
      valueKey={valueKey}
      apiPath={apiPath}
      searchKey={searchKey}
      field={field}
      {...props}
    />
  );
});

export default observer(ServiceProviderLocation);
